<template>
  <div class="about">
    <h1>This is an about page</h1>
    <vant-button type="primary">vantButton</vant-button>
  </div>
</template>

<script>
import { Button } from "vant"
export default {
  components: {
    "vant-button": Button,
  },
}
</script>
